<template>
    <div>
        <div class="card mb-4">
            <div class="card-header">
                <h2>Uitbetalingen voor {{ header }}</h2>
            </div>
            <div class="card-body">
                <div class="table-responsive">
                    <table v-if="payouts && payouts.length" class="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Naam</th>
                                <th>IBAN</th>
                                <th>Bedrag</th>
                                <th>Betaald</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(payout, key) in payouts" :key="key">
                                <td>{{ payout.lidnummer ? payout.lidnummer : 'lid verwijderd' }}</td>
                                <td>{{ payout.name ? payout.name : 'lid verwijderd' | limit }}</td>
                                <td>{{ payout.iban }}</td>
                                <td>€ {{ payout.bedrag | currency }}</td>
                                <td><input type="checkbox" v-model="payout.published" @change="submit(payout)"></td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>Er was niemand arbeidsongeschikt.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        payouts: {
            type: Array,
            default: () => [],
        },
        header: String,
    },
    data() {
        return {
            processing: false,
        }
    },
    methods: {
        submit(payout) {
            this.processing = true;

            this.axios
                .post('uitbetaling/' + payout.id, {
                    paid: payout.published
                })
                .catch(function (error) {
                    this.$notify({
                        group: 'base',
                        text: 'Er is iets misgegaan met het de status van het uitbetalen. Vernieuw de pagina om de actuele status te zien.',
                        type: 'alert-danger',
                    });
                })
                .finally(() => {
                    this.processing = false;
                })
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/Payouts.vue